/**
 * Returns the full URL for a static asset served from the assets CDN.
 * In production/staging, assets are served from assets.{domain}.
 * In local dev, assets are served from the local public folder.
 */
export function getAssetUrl(path: string): string {
  const hostname = window.location.hostname;

  // Local development — serve from public folder
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return path;
  }

  // Production/staging — serve from assets CDN
  // app.chatnexus.com → assets.chatnexus.com
  // staging.chatnexus.com → assets.staging.chatnexus.com
  const baseDomain = hostname.replace('www.', '').replace('app.', '');

  return `https://assets.${baseDomain}${path}`;
}
